import {useEffect, useState} from "react";
import {SurveyStatus} from "../../../redux/survey/survey.types";
import { useCreateSummaryMutation, useGetSurveySummaryQuery } from "src/redux/survey/summary.endpoints";
import {
  PAUSE_POLLING_WHEN_UNFOCUSED,
  SURVEY_SUMMARY_REFRESH_INTERVAL_MS,
} from "src/constants/polling.constants";

export const useSurveySummary = (extSurveyId: string, surveyStatus?: SurveyStatus, isShare?: boolean) => {
  const [isGeneratingSummary, setIsGeneratingSummary] = useState(false);
  const [pollingInterval, setPollingInterval] = useState<number | undefined>(undefined);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [planData, setPlanData] = useState<any>(null);

  const { data, error: planError, isFetching, refetch } = useGetSurveySummaryQuery(
    { ext_survey_id: extSurveyId, share: isShare },
    { pollingInterval, ...PAUSE_POLLING_WHEN_UNFOCUSED },
  );

  const [createSummary, { isLoading: isCreationLoading, isSuccess: createSuccess }] = useCreateSummaryMutation({
    fixedCacheKey: `summary-${extSurveyId}`,
  });

  const isLoadingSummary = isCreationLoading || isFetching;
  const summariesAvailable = planData && planData?.summaries.length > 0;

  useEffect(() => {
    if (createSuccess) {
      setIsGeneratingSummary(true);
      setPlanData(null);
      refetch();
    }

  }, [createSuccess, refetch]);

  useEffect(() => {
    if (data) {
      setPlanData(data);
    }
  }, [data]);

  useEffect(() => {
    if (planError) {
      setIsGeneratingSummary(false);
      return;
    }
    if (summariesAvailable) {
      setIsGeneratingSummary(false);
      setPollingInterval(undefined);
    } else if (isGeneratingSummary) {
      setPollingInterval(SURVEY_SUMMARY_REFRESH_INTERVAL_MS);
    }

  }, [planError, summariesAvailable, isGeneratingSummary]);

  const initiateSummaryCreation = () => {
    setIsGeneratingSummary(true);
    setPlanData(null);
    void createSummary({ ext_survey_id: extSurveyId });
  };

  return {
    canCreateSummary: !isShare && !isGeneratingSummary && !isLoadingSummary,
    createSummary: initiateSummaryCreation,
    isLoadingSummary,
    summaries: planData?.summaries,
    isGeneratingSummary,
  };
};